(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7477],{

/***/ 6811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CreatePostCallToAction_CreatePostCallToAction; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./schema/Space/queries.ts
var queries = __webpack_require__(73820);
// EXTERNAL MODULE: ./constants/featureFlags.ts
var constants_featureFlags = __webpack_require__(46139);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Row-ef6c768c.js
var Row_ef6c768c = __webpack_require__(93928);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/P-3714214d.js
var P_3714214d = __webpack_require__(61783);
// EXTERNAL MODULE: ./components/InfoCard/index.ts + 3 modules
var InfoCard = __webpack_require__(4069);
// EXTERNAL MODULE: ./components/Image/index.ts + 1 modules
var Image = __webpack_require__(82513);
// EXTERNAL MODULE: ./components/AdminOnlyIndicator/index.tsx
var AdminOnlyIndicator = __webpack_require__(31785);
// EXTERNAL MODULE: ./components/VisibilityCloak/VisibilityCloak.tsx
var VisibilityCloak = __webpack_require__(37510);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./components/WelcomeToSpace/WelcomeToSpace.module.scss
var WelcomeToSpace_module = __webpack_require__(82033);
var WelcomeToSpace_module_default = /*#__PURE__*/__webpack_require__.n(WelcomeToSpace_module);
;// CONCATENATED MODULE: ./components/WelcomeToSpace/WelcomeToSpace.tsx













var cx = bind_default().bind((WelcomeToSpace_module_default()));
var WelcomeToSpace = function() {
    var t = (0,es/* useTranslation */.$G)().t;
    var currentUser = (0,CommunityContext/* useCommunityContext */.v1)().currentUser;
    if (!(0,userHelpers/* isAdmin */.GJ)(currentUser)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx("mb-2"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoCard/* default */.Z, {
            dataQA: "welcome-to-spaces__card",
            localStorageKey: "hideWelcomeToSpaces",
            title: t("components-welcomeToSpace-welcome_to_space", "Welcome to Spaces"),
            isDismissable: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_ef6c768c.R, {
                    className: cx("welcome-to-space__wrapper"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_ef6c768c.a, {
                            lgColumns: 6,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(P_3714214d.P, {
                                    className: cx("welcome-to-space__description"),
                                    children: t("components-welcomeToSpace-description", "A Space is like a virtual room inside your Community. You can use Spaces to organize discussion topics, create groups, and encourage your members to ask questions and share their insights.")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(P_3714214d.P, {
                                    className: cx("welcome-to-space__hint"),
                                    children: t("components-welcomeToSpace-hint", "You can customize a Space\u2019s description and image by going to Settings on the top right.")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_ef6c768c.a, {
                            lgColumns: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
                                hideMD: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    className: cx("welcome-to-space__image"),
                                    height: 200,
                                    src: constants/* WELCOME_TO_SPACES */.oo,
                                    width: 213
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_ef6c768c.R, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_ef6c768c.a, {
                        smColumns: 10,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
                            admins: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdminOnlyIndicator/* default */.Z, {})
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var WelcomeToSpace_WelcomeToSpace = (WelcomeToSpace);

;// CONCATENATED MODULE: ./components/WelcomeToSpace/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Surface-649a6d6c.js
var Surface_649a6d6c = __webpack_require__(64828);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Input-b1273534.js + 2 modules
var Input_b1273534 = __webpack_require__(28032);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./components/UserAvatar/index.ts + 2 modules
var UserAvatar = __webpack_require__(82957);
// EXTERNAL MODULE: ./schema/Post/mutations.ts
var mutations = __webpack_require__(74266);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/toaster-a57afb61.js
var toaster_a57afb61 = __webpack_require__(81792);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./koba/components/Modal/index.js + 1 modules
var Modal = __webpack_require__(97971);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
// EXTERNAL MODULE: ./helpers/postHelpers.ts
var postHelpers = __webpack_require__(68642);
// EXTERNAL MODULE: ./components/Forms/Post/index.ts + 3 modules
var Post = __webpack_require__(81475);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./components/CreateNewPost/CreateNewPost.module.scss
var CreateNewPost_module = __webpack_require__(89702);
var CreateNewPost_module_default = /*#__PURE__*/__webpack_require__.n(CreateNewPost_module);
;// CONCATENATED MODULE: ./components/CreateNewPost/CreateNewPostModal.tsx




















var MAX_TITLE_LENGTH = 124;
var CreateNewPostModal_cx = bind_default().bind((CreateNewPost_module_default()));
var CreateNewPostModal = function(param) {
    var closeModal = param.closeModal, communityId = param.communityId, currentSpace = param.currentSpace, createNewPostMutation = param.createNewPostMutation, hasAutoFocus = param.hasAutoFocus, isLoading = param.isLoading, primaryColor = param.primaryColor, s3UploadPath = param.s3UploadPath, trackEvent = param.trackEvent;
    var t = (0,es/* useTranslation */.$G)().t;
    var featureFlags = (0,CommunityContext/* useCommunityContext */.v1)().featureFlags;
    var isDebuggingEnabled = featureFlags[constants_featureFlags/* features.DEV_COMMUNITIES_DEBUGGING */.R.DEV_COMMUNITIES_DEBUGGING];
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isPhone = width < constants/* SCREEN_PHONE */.SO;
    var ref = (0,react.useState)(false), isSubmitting = ref[0], setIsSubmitting = ref[1];
    var ref1 = (0,react.useState)(false), isFormDirty = ref1[0], setIsFormDirty = ref1[1];
    var ref2 = (0,react.useState)([]), usersMentioned = ref2[0], setUsersMentioned = ref2[1];
    (0,react.useEffect)(function() {
        // Tracking the post modal to compare against
        // creation events for drop-off.
        trackEvent(trackingEvents/* default.POST_MODAL_OPENED */.ZP.POST_MODAL_OPENED);
    }, []);
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var ref, ref1, startTime, postInput, variables, ref2, createPostData, createPostError, endTime, createPostDuration, ref3, ATTACHMENT, POST_TYPE, HAS_MENTION, _obj, userErrors, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setIsSubmitting(true);
                        startTime = new Date().getTime();
                        postInput = data.attachment ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.attachment), {
                            altText: data.attachmentAltText
                        }) : null;
                        variables = {
                            discussionableId: communityId,
                            title: data.title,
                            content: data.content,
                            postAttachment: (0,postHelpers/* sanitizeAttachments */.O)(postInput)
                        };
                        variables.spaceId = (currentSpace === null || currentSpace === void 0 ? void 0 : currentSpace.id) || (data === null || data === void 0 ? void 0 : data.spaceId);
                        if (usersMentioned === null || usersMentioned === void 0 ? void 0 : usersMentioned.length) {
                            variables.mentionedUserIds = usersMentioned;
                        }
                        _ctx.next = 9;
                        return createNewPostMutation({
                            variables: variables,
                            refetchQueries: [
                                "PostList",
                                "CommunitySpace"
                            ]
                        });
                    case 9:
                        ref2 = _ctx.sent;
                        createPostData = ref2.data;
                        createPostError = ref2.errors;
                        endTime = new Date().getTime();
                        if (isDebuggingEnabled) {
                            createPostDuration = endTime - startTime;
                            if (createPostDuration > 5000) {
                                ;
                                window === null || window === void 0 ? void 0 : (ref3 = window.airbrake) === null || ref3 === void 0 ? void 0 : ref3.notify({
                                    error: "Create Post Exceeded 5 seconds",
                                    params: {
                                        duration: createPostDuration
                                    },
                                    context: {
                                        severity: "warning",
                                        component: "CreateNewPostModal"
                                    }
                                });
                            }
                        }
                        ATTACHMENT = trackingEvents/* TrackingProperty.ATTACHMENT */.Ku.ATTACHMENT, POST_TYPE = trackingEvents/* TrackingProperty.POST_TYPE */.Ku.POST_TYPE, HAS_MENTION = trackingEvents/* TrackingProperty.HAS_MENTION */.Ku.HAS_MENTION;
                        ;
                        trackEvent(trackingEvents/* default.POST_CREATED */.ZP.POST_CREATED, (_obj = {}, (0,_define_property/* default */.Z)(_obj, ATTACHMENT, data.attachment ? (ref = data.attachment) === null || ref === void 0 ? void 0 : ref.attachmentType : null), (0,_define_property/* default */.Z)(_obj, POST_TYPE, constants/* EVENT_POST_TYPES.POST */.Aj.POST), (0,_define_property/* default */.Z)(_obj, HAS_MENTION, !!(usersMentioned === null || usersMentioned === void 0 ? void 0 : usersMentioned.length)), _obj));
                        userErrors = createPostData === null || createPostData === void 0 ? void 0 : (ref1 = createPostData.createPost) === null || ref1 === void 0 ? void 0 : ref1.userErrors;
                        if (!(userErrors === null || userErrors === void 0 ? void 0 : userErrors.length) && !(createPostError === null || createPostError === void 0 ? void 0 : createPostError.length)) {
                            toaster_a57afb61.t.notice(t(constants/* SUCCESS_TOAST.CREATE_POST */.Gy.CREATE_POST));
                            closeModal();
                            window.scrollTo(0, 0);
                        } else {
                            if (isDebuggingEnabled) {
                                ;
                                window === null || window === void 0 ? void 0 : (ref4 = window.airbrake) === null || ref4 === void 0 ? void 0 : ref4.notify({
                                    error: "Create Post Error",
                                    params: {
                                        userErrors: userErrors,
                                        createPostError: createPostError
                                    },
                                    context: {
                                        severity: "error",
                                        component: "CreateNewPostModal"
                                    }
                                });
                            }
                            (0,toastHelpers/* genericToastAlert */.d9)();
                        }
                        setIsSubmitting(false);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCloseModal = function() {
        if (isFormDirty && !isSubmitting) {
            // eslint-disable-next-line no-alert
            if (window.confirm(t("Are you sure you want to discard your post?"))) {
                closeModal();
            }
        } else {
            closeModal();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        closeModal: handleCloseModal,
        dataQA: "modal__create-new-post",
        modalBodyClasses: CreateNewPostModal_cx("modal__create-new-post", {
            mobile: isPhone
        }),
        title: (currentSpace === null || currentSpace === void 0 ? void 0 : currentSpace.name) ? t("Create new post in {{spaceName}}", {
            spaceName: currentSpace.name
        }) : t("Create new post"),
        isOpen: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Post/* default */.Z, {
            closeModal: handleCloseModal,
            hasAutoFocus: hasAutoFocus,
            initValues: {
                title: "",
                content: "",
                attachment: null,
                attachmentAltText: ""
            },
            isLoading: isLoading,
            primaryColor: primaryColor,
            s3UploadPath: s3UploadPath,
            setIsFormDirty: setIsFormDirty,
            setUsersMentioned: setUsersMentioned,
            submitLabel: t("Create post"),
            usersMentioned: usersMentioned,
            onSubmit: handleSubmit
        })
    });
};
CreateNewPostModal.defaultProps = {
    hasAutoFocus: false
};
/* harmony default export */ var CreateNewPost_CreateNewPostModal = (CreateNewPostModal);

// EXTERNAL MODULE: ./constants/eventNames.ts
var eventNames = __webpack_require__(81340);
;// CONCATENATED MODULE: ./hooks/useSlowRequestHandler.ts


var useSlowRequestHandler = function(isLoading, message) {
    var ref = (0,react.useState)(), currentTimerId = ref[0], setTimer = ref[1];
    (0,react.useEffect)(function() {
        if (isLoading === true) {
            var timerId = setTimeout(function() {
                if (isLoading === true) {
                    toaster_a57afb61.t.info(message, {
                        autoClose: 10000
                    });
                }
            }, 4000);
            setTimer(timerId);
        } else if (currentTimerId != null) {
            clearTimeout(currentTimerId);
        }
        return function() {
            if (currentTimerId) {
                clearTimeout(currentTimerId);
            }
        };
    }, [
        isLoading
    ]);
};
/* harmony default export */ var hooks_useSlowRequestHandler = (useSlowRequestHandler);

// EXTERNAL MODULE: ./components/CreatePostCallToAction/CreatePostCallToAction.module.scss
var CreatePostCallToAction_module = __webpack_require__(66870);
var CreatePostCallToAction_module_default = /*#__PURE__*/__webpack_require__.n(CreatePostCallToAction_module);
;// CONCATENATED MODULE: ./components/CreatePostCallToAction/components/CallToActionInput.tsx















var CallToActionInput_cx = bind_default().bind((CreatePostCallToAction_module_default()));
var CallToActionInput = function(param) {
    var ariaLabel = param.ariaLabel, currentSpace = param.currentSpace, dataQA = param.dataQA, inputId = param.inputId, isModalOpen = param.isModalOpen, setIsModalOpen = param.setIsModalOpen, placeholderText = param.placeholderText;
    var handleOnClick = function handleOnClick() {
        document.body.style.overflow = isModalOpen ? "visible" : "hidden";
        setIsModalOpen(!isModalOpen);
        var input = document.querySelector("#space-create-post__textfield-id");
        input === null || input === void 0 ? void 0 : input.blur();
    };
    var handleToggleModal = function handleToggleModal(event) {
        if ((event === null || event === void 0 ? void 0 : event.key) !== "Tab" && (event === null || event === void 0 ? void 0 : event.key) !== "Shift" && (event === null || event === void 0 ? void 0 : event.key) !== "Escape") {
            handleOnClick();
        }
    };
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* CREATE_POST_MUTATION */.dl), 2), createNewPostMutation = ref[0], loading = ref[1].loading;
    hooks_useSlowRequestHandler(loading, t("components-callToActionInput-posts_slow_to_publish_toast", "This post is taking longer to publish than usual. You can close the modal and refresh the page. Your post will appear soon."));
    var ref1 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref1.community, trackEvent = ref1.trackEvent, currentUser = ref1.currentUser;
    var id = currentUser.id, avatarUrl = currentUser.avatarUrl, fullName = currentUser.fullName;
    var srcSet = "".concat(avatarUrl, "?width=40 1x, ").concat(avatarUrl, "?width=40&dpr=2 2x, ").concat(avatarUrl, "?width=40&dpr=3 3x");
    var createNewPostProps = {
        closeModal: handleOnClick,
        communityId: community.id,
        createNewPostMutation: createNewPostMutation,
        hasAutoFocus: true,
        isLoading: loading,
        isOpen: isModalOpen,
        currentSpace: currentSpace,
        primaryColor: community.primaryColor,
        s3UploadPath: community.s3UploadPath,
        trackEvent: trackEvent
    };
    (0,react.useEffect)(function() {
        var modalOpen = PubSub.subscribe(eventNames/* eventNames.OPEN_POST_MODAL */.S.OPEN_POST_MODAL, function() {
            return setIsModalOpen(true);
        });
        return function() {
            PubSub.unsubscribe(modalOpen);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Surface_649a6d6c.S, {
                className: CallToActionInput_cx("call-to-action__container"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: CallToActionInput_cx("call-to-action__avatar-wrapper"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                            avatarUrl: avatarUrl,
                            className: CallToActionInput_cx("call-to-action__avatar-container"),
                            size: "sm",
                            srcSet: srcSet,
                            userId: id,
                            username: fullName || "",
                            shouldOpenProfile: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_b1273534.I, {
                        ariaLabel: ariaLabel,
                        extraClasses: CallToActionInput_cx("call-to-action__input"),
                        extraProps: {
                            "data-qa": dataQA,
                            id: inputId,
                            onKeyDown: handleToggleModal,
                            onClick: handleOnClick
                        },
                        placeholder: placeholderText
                    })
                ]
            }),
            isModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateNewPost_CreateNewPostModal, (0,_object_spread/* default */.Z)({}, createNewPostProps))
        ]
    });
};
/* harmony default export */ var components_CallToActionInput = (CallToActionInput);

// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Icon-343b84c4.js
var Icon_343b84c4 = __webpack_require__(42990);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Tooltip-00b73669.js
var Tooltip_00b73669 = __webpack_require__(20021);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/IconButton-9b57b44f.js
var IconButton_9b57b44f = __webpack_require__(65569);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./helpers/spaceHelpers.ts
var spaceHelpers = __webpack_require__(68556);
;// CONCATENATED MODULE: ./components/CreatePostCallToAction/components/SpaceInfo.tsx














var SpaceInfo_cx = bind_default().bind((CreatePostCallToAction_module_default()));
var SpaceInfo = function(param) {
    var currentSpace = param.currentSpace;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref.community, currentUser = ref.currentUser, featureFlags = ref.featureFlags;
    var router = (0,next_router.useRouter)();
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var spaceId = router.query.spaceId;
    var isMobile = width < constants/* BREAKPOINT_MD */.GI;
    var isExclusiveSpacesEnabled = featureFlags[constants_featureFlags/* features.EXCLUSIVE_SPACES */.R.EXCLUSIVE_SPACES];
    var isExclusive = isExclusiveSpacesEnabled && !!currentSpace.isExclusive;
    var name = currentSpace.name;
    var spaceName = isExclusive ? t("components-spaceInfo-exclusive_space_title", "{{spaceName}} (Exclusive Space)", {
        spaceName: name
    }) : name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: spaceId && currentSpace && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: SpaceInfo_cx("call-to-action__wrapper"),
            children: !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: SpaceInfo_cx("call-to-action__header"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: SpaceInfo_cx("call-to-action__space"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                                color: community.primaryColor,
                                name: (0,spaceHelpers/* getIconNameByStoredValue */.i)(currentSpace === null || currentSpace === void 0 ? void 0 : currentSpace.iconName)
                            }),
                            spaceName
                        ]
                    }),
                    (0,userHelpers/* isAdmin */.GJ)(currentUser) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_00b73669.T, {
                        title: t("pages-edit_space_title", "Space Settings"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_9b57b44f.I, {
                            appearance: "utility",
                            "aria-label": t("Click to edit the Space information"),
                            className: SpaceInfo_cx("call-to-action__header-button"),
                            "data-qa": "settings-gear-icon",
                            name: "cog",
                            title: t("Click to edit the Space information"),
                            onClick: function() {
                                return (0,routerHelpers/* goToEditSpace */.Z4)(router, spaceId, community.id);
                            }
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_SpaceInfo = (SpaceInfo);

;// CONCATENATED MODULE: ./components/CreatePostCallToAction/CreatePostCallToAction.tsx













var CreatePostCallToAction_cx = bind_default().bind((CreatePostCallToAction_module_default()));
var CreatePostCallToAction = function(param) {
    var ariaLabel = param.ariaLabel, dataQA = param.dataQA, inputId = param.inputId, isModalOpen = param.isModalOpen, setIsModalOpen = param.setIsModalOpen, setSpaceName = param.setSpaceName, placeholderText = param.placeholderText;
    var ref;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref1 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref1.community, featureFlags = ref1.featureFlags;
    var router = (0,next_router.useRouter)();
    var spaceId = router.query.spaceId;
    var isCoursesToCommunitiesEnabled = featureFlags[constants_featureFlags/* features.COURSES_TO_COMMUNITIES */.R.COURSES_TO_COMMUNITIES];
    var currentSpace = {};
    var data = (0,useQuery/* useQuery */.a)(queries/* SPACE_QUERY */.y, {
        variables: {
            communityId: community.id,
            spaceId: spaceId,
            isCoursesToCommunitiesEnabled: isCoursesToCommunitiesEnabled
        },
        notifyOnNetworkStatusChange: true,
        skip: !spaceId
    }).data;
    if (data === null || data === void 0 ? void 0 : data.community) {
        currentSpace = data.community.communitySpace;
    }
    var showCallToAction = !!((ref = currentSpace.posts) === null || ref === void 0 ? void 0 : ref.totalCount) || isModalOpen || !spaceId;
    (0,react.useEffect)(function() {
        if (currentSpace) setSpaceName === null || setSpaceName === void 0 ? void 0 : setSpaceName(currentSpace.name);
    }, [
        currentSpace
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: CreatePostCallToAction_cx("call-to-action__wrapper"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SpaceInfo, {
                    currentSpace: currentSpace
                }),
                spaceId && /*#__PURE__*/ (0,jsx_runtime.jsx)(WelcomeToSpace_WelcomeToSpace, {}),
                showCallToAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CallToActionInput, {
                    ariaLabel: ariaLabel || t("components-createPostCallToAction-write_a_post_placeholder_text", "Write a post in {{space}}...", {
                        space: currentSpace.name
                    }),
                    currentSpace: currentSpace,
                    dataQA: dataQA || "space-create-post__textfield",
                    inputId: inputId || "space-create-post__textfield-id",
                    isModalOpen: isModalOpen,
                    placeholderText: placeholderText || t("components-createPostCallToAction-write_a_post_placeholder_text", "Write a post in {{space}}...", {
                        space: currentSpace.name
                    }),
                    setIsModalOpen: setIsModalOpen
                })
            ]
        })
    });
};
/* harmony default export */ var CreatePostCallToAction_CreatePostCallToAction = (CreatePostCallToAction);

;// CONCATENATED MODULE: ./components/CreatePostCallToAction/index.ts



/***/ }),

/***/ 6724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67421);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9973);
/* harmony import */ var koba_components_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99438);
/* harmony import */ var constants_trackingEvents__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89131);
/* harmony import */ var components_InfoCard_EmptyStateCard_EmptyStateCard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21438);








var CreatePostCard = function(param) {
    var onClick = param.onClick, title = param.title, content = param.content, _dataQA = param.dataQA, dataQA = _dataQA === void 0 ? "create-post-card" : _dataQA, imageSrc = param.imageSrc;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var ref = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_3__/* .useCommunityContext */ .v1)(), community = ref.community, trackEvent = ref.trackEvent;
    var handleClickOnPostCTA = function() {
        trackEvent(constants_trackingEvents__WEBPACK_IMPORTED_MODULE_5__/* ["default"].POST_MODAL_OPENED */ .ZP.POST_MODAL_OPENED, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_5__/* .TrackingProperty.COMPONENT */ .Ku.COMPONENT, "CreatePostCard"));
        onClick();
    };
    var createPostCardButton = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(koba_components_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        appearance: "default",
        ariaLabel: t("components-infoCard-createPostCard-call_to_action_aria_label", "Click to create a post"),
        color: community.primaryColor,
        "data-qa": "".concat(dataQA, "__button-create"),
        onClick: handleClickOnPostCTA,
        children: t("components-infoCard-createPostCard-create_post_button_text", "Create post")
    }, "create-post-card__button-create");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_InfoCard_EmptyStateCard_EmptyStateCard__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        content: content,
        dataQA: dataQA,
        emptyStateAction: createPostCardButton,
        imageSrc: imageSrc,
        title: title,
        hasAdminSection: true
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CreatePostCard);


/***/ }),

/***/ 89702:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"CreateNewPost_sr-only--mobile__DsMaX","sr-only":"CreateNewPost_sr-only__zoDGN","error-message":"CreateNewPost_error-message__xLYAL","form-inline-edit":"CreateNewPost_form-inline-edit__Zr1HY","form-group":"CreateNewPost_form-group__dXmi_","form-row":"CreateNewPost_form-row__kpcVl","form-inline":"CreateNewPost_form-inline__E5sj4","error":"CreateNewPost_error__zwQva","input-group-append":"CreateNewPost_input-group-append__TGHv_","input-group-currency":"CreateNewPost_input-group-currency__ALjXe","form-control":"CreateNewPost_form-control__3EGIF","custom-select":"CreateNewPost_custom-select__1A5yv","is-invalid":"CreateNewPost_is-invalid__ZeZf_","is-valid":"CreateNewPost_is-valid__i5aUO","input-group":"CreateNewPost_input-group___wg7X","input-group-text":"CreateNewPost_input-group-text__DeabL","input-group-prepend":"CreateNewPost_input-group-prepend__v9w3S","valid-feedback":"CreateNewPost_valid-feedback__S0eEF","invalid-feedback":"CreateNewPost_invalid-feedback__n___6","form-text":"CreateNewPost_form-text___Y2G3","label":"CreateNewPost_label__tfFC0","custom-control":"CreateNewPost_custom-control___tulP","custom-control-label":"CreateNewPost_custom-control-label__xCA6o","custom-control-label--empty":"CreateNewPost_custom-control-label--empty__elEeF","custom-control-input":"CreateNewPost_custom-control-input__DggDb","create-post":"CreateNewPost_create-post__LQGsC","create-post__button":"CreateNewPost_create-post__button__S1gcN","create-post__button--dark-text":"CreateNewPost_create-post__button--dark-text__23TLX","modal__create-new-post":"CreateNewPost_modal__create-new-post__5NfO1","mobile":"CreateNewPost_mobile__sTeWT"};

/***/ }),

/***/ 66870:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"CreatePostCallToAction_sr-only--mobile__SsBs2","sr-only":"CreatePostCallToAction_sr-only__iEQLM","error-message":"CreatePostCallToAction_error-message__9povZ","form-inline-edit":"CreatePostCallToAction_form-inline-edit__ZIUnS","form-group":"CreatePostCallToAction_form-group__6s1o7","form-row":"CreatePostCallToAction_form-row__pk68j","form-inline":"CreatePostCallToAction_form-inline__pswtR","error":"CreatePostCallToAction_error__A_23X","input-group-append":"CreatePostCallToAction_input-group-append__KWb0a","input-group-currency":"CreatePostCallToAction_input-group-currency___BCaK","form-control":"CreatePostCallToAction_form-control__xEqhr","custom-select":"CreatePostCallToAction_custom-select__TB0Il","is-invalid":"CreatePostCallToAction_is-invalid__CaHkY","is-valid":"CreatePostCallToAction_is-valid__BtoUF","input-group":"CreatePostCallToAction_input-group__hfnUk","input-group-text":"CreatePostCallToAction_input-group-text__FRL8a","input-group-prepend":"CreatePostCallToAction_input-group-prepend__XCiLm","valid-feedback":"CreatePostCallToAction_valid-feedback__bvy_S","invalid-feedback":"CreatePostCallToAction_invalid-feedback__dXM1s","form-text":"CreatePostCallToAction_form-text__sfzIG","label":"CreatePostCallToAction_label__yaF8Q","custom-control":"CreatePostCallToAction_custom-control__RMN0v","custom-control-label":"CreatePostCallToAction_custom-control-label__h105p","custom-control-label--empty":"CreatePostCallToAction_custom-control-label--empty__VUXnN","custom-control-input":"CreatePostCallToAction_custom-control-input__YfnAT","call-to-action__wrapper":"CreatePostCallToAction_call-to-action__wrapper__vHNIU","call-to-action__header":"CreatePostCallToAction_call-to-action__header___YJzb","call-to-action__space":"CreatePostCallToAction_call-to-action__space__1CLGi","call-to-action__container":"CreatePostCallToAction_call-to-action__container__vNMpG","call-to-action__avatar":"CreatePostCallToAction_call-to-action__avatar__s792G","call-to-action__avatar-wrapper":"CreatePostCallToAction_call-to-action__avatar-wrapper__vy12x","call-to-action__avatar-wrapper-container":"CreatePostCallToAction_call-to-action__avatar-wrapper-container__xOVZb","call-to-action__input":"CreatePostCallToAction_call-to-action__input__R2umH"};

/***/ }),

/***/ 82033:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"WelcomeToSpace_sr-only--mobile__cb_nq","sr-only":"WelcomeToSpace_sr-only__Wdwja","error-message":"WelcomeToSpace_error-message__SO696","form-inline-edit":"WelcomeToSpace_form-inline-edit__aqEb_","form-group":"WelcomeToSpace_form-group__TzD6H","form-row":"WelcomeToSpace_form-row__Kmqrp","form-inline":"WelcomeToSpace_form-inline__pLr1O","error":"WelcomeToSpace_error__k_bUi","input-group-append":"WelcomeToSpace_input-group-append__6yO07","input-group-currency":"WelcomeToSpace_input-group-currency__J8xdV","form-control":"WelcomeToSpace_form-control__N9kj7","custom-select":"WelcomeToSpace_custom-select__ShZus","is-invalid":"WelcomeToSpace_is-invalid__29pcL","is-valid":"WelcomeToSpace_is-valid___qym_","input-group":"WelcomeToSpace_input-group__oWhwR","input-group-text":"WelcomeToSpace_input-group-text__LNIbF","input-group-prepend":"WelcomeToSpace_input-group-prepend__RlHGQ","valid-feedback":"WelcomeToSpace_valid-feedback__EUkoG","invalid-feedback":"WelcomeToSpace_invalid-feedback__st6QU","form-text":"WelcomeToSpace_form-text__CiXl5","label":"WelcomeToSpace_label__6NWZI","custom-control":"WelcomeToSpace_custom-control__syoPs","custom-control-label":"WelcomeToSpace_custom-control-label__1ZOIl","custom-control-label--empty":"WelcomeToSpace_custom-control-label--empty__0Nfmq","custom-control-input":"WelcomeToSpace_custom-control-input__vE_wI","mx-3":"WelcomeToSpace_mx-3__axoen","mb-1":"WelcomeToSpace_mb-1__ZrMUc","mb-2":"WelcomeToSpace_mb-2__alEZo","mb-3":"WelcomeToSpace_mb-3__YZ3WP","mb-4":"WelcomeToSpace_mb-4__zFgk9","mb-5":"WelcomeToSpace_mb-5__hxZ5T","mt-2":"WelcomeToSpace_mt-2__nSXH5","ml-1":"WelcomeToSpace_ml-1__S0QIE","p-2":"WelcomeToSpace_p-2__V6h2x","p-3":"WelcomeToSpace_p-3__DD7eI","border-box":"WelcomeToSpace_border-box__x4WS4","d-inline-block":"WelcomeToSpace_d-inline-block__SA3mw","welcome-to-space__wrapper":"WelcomeToSpace_welcome-to-space__wrapper___1zr7","welcome-to-space__description":"WelcomeToSpace_welcome-to-space__description__nqMRM","welcome-to-space__hint":"WelcomeToSpace_welcome-to-space__hint___zW6A"};

/***/ })

}]);